<template>
  <section id="formulario" class="bg-[#052625] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white rounded-lg p-6">

        <div class="w-full pb-6 text-center">
          <h1 class="plex-semibold text-3xl text-gray-800">ACREDITACIÓN</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2">
            <label class="block mb-1">Tipo de acreditado</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoAcreditado">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el tipo de acreditado" :options="tiposAcreditados" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditado" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" @blur="validarDni" placeholder="DNI / Pasaporte" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Empresa" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Profesión/Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" placeholder="Profesión/Cargo" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>

          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País</label>
            <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.pais">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="País" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="pais" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text" placeholder="Ingrese su provincia o estado" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaEstado" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id == '+54'">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.localidad">
              <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la localidad" class="input-base" :options="localidades" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.pais?.id != '+54'">
            <label class="block mb-1">Localidad / Ciudad</label>
            <Field name="localidadCiudad" v-slot="{ field, errors }" v-model="formData.localidadCiudad">
              <InputText v-bind="field" type="text" placeholder="Ingrese su localidad o ciudad" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidadCiudad" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Prefijo</label>
            <InputText type="text" v-if="formData.pais !== null" v-model="formData.pais.id" class="input-base input-success" readonly />
          </div>
          <div class="w-full md:w-3/12 px-2">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" placeholder="Código de área" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full md:w-6/12 px-2">
            <label class="block mb-1">Celular (WhtasApp)</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" placeholder="Número de celular" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import FullScreenLoader from './FullScreenLoader.vue';


import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';
import jsonTiposAcreditados from '@/data/tiposAcreditados.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";


interface Pais extends StringIdLabelEntity { }
interface Localidad extends IdLabelEntity { }
interface Provincia extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select,
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      paises: jsonCountries as Pais[],
      localidades: jsonLocalidades as Localidad[],
      provincias: jsonProvincias as Provincia[],
      tiposAcreditados: jsonTiposAcreditados as TipoAcreditado[],
      isSubmitting: false,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        empresa: '',
        codigoArea: '',
        telefonoCelular: '',
        mail: '',
        pais: { "id": "+54", "descripcion": "Argentina" } as Pais,
        provincia: undefined as unknown as Provincia,
        localidad: undefined as unknown as Localidad,
        provinciaEstado: '',
        localidadCiudad: '',
        cargo: '',
        tipoAcreditado: undefined as unknown as TipoAcreditado,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        tipoAcreditado: yup.mixed().required('Seleccione el tipo de acreditad'),
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        codigoArea: yup.string().required('Ingrese el código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        empresa: yup.string().required('Ingrese la empresa').min(2, 'Al menos 2 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        cargo: yup.string().required('Seleccione el cargo'),

        provincia: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidad: yup.mixed().test('validacion-localidad-argentina', 'Seleccione la localidad', function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', 'Ingrese la provincia/estado', function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidadCiudad: yup.string().test('validacion-localidad-otro', 'Ingrese la localidad/ciudad', function (value) {
          const paisSelected = this.parent.pais;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),

      });
    }
  },
  watch: {
    'formData.provincia.id'(newValue) {
      if (newValue) {
        this.localidades = jsonLocalidades;
        this.localidades = this.localidades.filter((localidad: Localidad) => localidad.id === newValue);
      }
    }
  },  
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async validarDni() {
      try {
        if (this.formData.dni) {
          this.isSubmitting = true;
          let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.dni) as Acreditado;
          if (acreditadoExistente) {
            Swal.fire({ title: "¡Atención!", html: "El DNI ya existe", icon: "warning" });
            return;
          }
        }
      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },     
    async onSubmit() {
      let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "El documento ingresado ya se encuentra registrado en una solicitud de acreditación.<br><br>En caso de no recibir el correo electrónico puede descargar la credencial desde el botón \"YA ME ACREDITÉ\" de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }

      this.isSubmitting = true;

      let acreditado: Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = this.formData.tipoAcreditado;
      acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.telefono = this.formData.pais.id + this.formData.codigoArea + this.formData.telefonoCelular;
      acreditado.mail = this.formData.mail;
      acreditado.empresa = this.formData.empresa;
      acreditado.cargo = this.formData.cargo;

      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;

      acreditado.dato3 = this.formData.pais?.descripcion;
      if (this.formData.pais?.id == "+54") {
        acreditado.dato1 = this.formData.provincia?.descripcion;
        acreditado.dato2 = this.formData.localidad?.descripcion;
      } else {
        acreditado.dato1 = this.formData.provinciaEstado;
        acreditado.dato2 = this.formData.localidadCiudad;
      }

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        Swal.fire({
          title: "¡Ya estás inscripto al Congreso Internacional de Maíz 2026!",
          html: "Te enviamos un correo con un QR para agilizar tu ingreso al evento<br/><br/>Recordá revisar tu casilla de correo y spam<br/>Si no recibis el correo podes cargar tu QR desde esta página mediante el botón 'YA ME ACREDITÉ'",
          icon: "success",
        }).then(() => {
          window.location.href = "https://congresointernacionaldemaiz.com.ar";
        });

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
  }
});
</script>
